import { render } from "./VaUnauthorizedSimple.vue?vue&type=template&id=c664c456"
import script from "./VaUnauthorizedSimple.vue?vue&type=script&lang=js"
export * from "./VaUnauthorizedSimple.vue?vue&type=script&lang=js"

import "./VaUnauthorizedSimple.vue?vue&type=style&index=0&id=c664c456&lang=scss"
script.render = render

export default script